import * as RoleConfigurationConst from 'constants/RoleConfigurationConst'
import StringConst from 'constants/StringConst'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isArrayIncludesAny } from 'utilities/JSUtil'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem, setSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './SubmitForReview.scss'

class SubmitForReview extends Component {

    constructor(props) {
        super(props)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        let onboardingStatus = getSessionItem(SessionConst.ONBOARDING_STATUS)
        let user = getSessionItem(SessionConst.USER)

        const isReadOnly = getSessionItem(SessionConst.IS_READ_ONLY) === FormConst.VALUE_NO ? false : true
        const isSubmitted = getSessionItem(SessionConst.IS_SUBMITTED) === FormConst.VALUE_YES ? true : false
        
        if (!(hotelCode || hotelInfo || onboardingStatus || onboardingStatus.hotelOnboardingId || user)) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }
        const isAdmin = user.isAdmin
        const isHotelContact = user.isHotelContact

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            onboardingStatus: onboardingStatus,
            user: user,
            isHotelContact: isHotelContact,
            isReadOnly: isReadOnly,
            isSubmitted: isSubmitted,
            isAdmin: isAdmin,
            initialValues: {},
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            showRedirectModal: false,
            showSubmitModal: false,
            stateInError: onboardingStatus.stateInError
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.count !== this.props.count) {
            // Http request completed - Only PUT in this page, so check for response
            if (this.props.errorMessage) {
                this.setState({ isLoading: false, showErrorModal: true })
            } else {
                setSessionItem(SessionConst.IS_SUBMITTED, FormConst.VALUE_YES)
                setSessionItem(SessionConst.IS_READ_ONLY, FormConst.VALUE_YES)
                this.setState({
                    isReadOnly: true,
                    isLoading: false,
                    isSubmitted: true
                })
            }
        }
    }

    handleSubmit = (data) => {
        this.props.onPutStatus({
            hotelOnboardingId: this.state.onboardingStatus.hotelOnboardingId, formData: {
                ...this.state.onboardingStatus,
                status: FormConst.STATUS_READY_FOR_REVIEW
            }
        })

        this.setState({ isLoading: true, showSubmitModal: false })
    }

    render() {
        return (
            <div id='submit-for-review-form' className='submit-for-review-form'>
                {/* <img id='submit-for-review-logo' className='submit-for-review-logo' src={logo} /> */}
                {/* <img id='submit-for-review-brand-logo' className='submit-for-review-brand-logo' src={getBrandLogo(this.state.hotelInfo)} /> */}
                {/* <dl className='hotel-details'> */}
                {/* <dt>Hotel code</dt> */}
                {/* <dd>{this.state.hotelCode}</dd> */}
                {/* <dt>Brand code</dt>
                    <dd>{this.state.hotelInfo.brandCode}</dd> */}
                {/* </dl> */}
                <Formik
                    initialValues={this.state.initialValues}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, handleChange, resetForm }) => (
                            <Form className='submit-for-review-form-element'>
                                <div id='submit-for-review-form-fields' className='submit-for-review-form-fields'>
                                    {
                                        this.state.isSubmitted
                                            ? (
                                                <>
                                                    <div className='submit-for-review-form-helper-text'>
                                                        <h4>Congratulations, {this.state.user.fullname}.</h4>
                                                        <h5>You have successfully submitted your application for review.</h5>
                                                    </div>
                                                    <Button className='submit' name='Home Page'
                                                        onClick={() => this.props.history.push(RouteConst.ROUTE_HOME_PAGE)}
                                                        overridedisabledflag='true' />
                                                </>
                                            )
                                            : (
                                                this.state.stateInError
                                                    ? <>
                                                        <div className='submit-for-review-form-helper-text'>
                                                            <h5>This application is in an error state. Please contact your {FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.</h5>
                                                        </div>
                                                        <Button className='submit' name='Home Page'
                                                            onClick={() => this.props.history.push(RouteConst.ROUTE_HOME_PAGE)}
                                                            overridedisabledflag='true' />
                                                    </>
                                                    : <>
                                                        <div className='submit-for-review-form-helper-text'>
                                                            <h4>Well done, {this.state.user.fullname}.</h4>
                                                            <h5>You have completed all the Onboarding forms and can now submit the application for review.</h5>
                                                        </div>
                                                        <Button className='submit' name='Submit For Review'
                                                            onClick={() => this.setState({
                                                                showSubmitModal: true
                                                            })} />
                                                    </>

                                            )
                                    }
                                </div>
                                <FormModal
                                    id='submit-for-review-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='submit-for-review-page-redirect-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={'Status updated'}
                                    body={<h5>{'Application status modified. Please reopen the application for updated state.'}</h5>}
                                    proceed={() => this.props.history.push(RouteConst.ROUTE_HOME_PAGE)}
                                    proceedName='Home Page'
                                    show={this.state.showRedirectModal} />
                                <FormModal
                                    id='submit-for-review-page-submit-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={'Submit Application'}
                                    body={
                                        <h5>
                                            I have reviewed the information completed in this {StringConst.APP_NAME} form,
                                            and I attest that the information is accurate and was provided by an authorized agent
                                            for {this.state.hotelCode}.
                                        </h5>
                                    }
                                    footerBody={
                                        <>
                                            <Button
                                                name='Cancel'
                                                role='secondary'
                                                onClick={
                                                    () => this.setState({
                                                        showSubmitModal: false
                                                    })
                                                }
                                                overridedisabledflag='true' />
                                            <Button
                                                name='Approve'
                                                onClick={
                                                    () => { this.handleSubmit(values) }
                                                }
                                                overridedisabledflag='true' />
                                        </>
                                    }
                                    show={this.state.showSubmitModal} />
                                <FormModal
                                    id='submit-for-review-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{FormConst.MODAL_UPDATE_ACTION_ERROR_TEXT}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        onboardingStatusResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPutStatus: (data) => dispatch(asyncMethod(FormConst.FORM_FEEDBACK_NAME, actionTypes.ASYNC_ACTIONS.PUT_ONBOARDING_STATUS, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(SubmitForReview, SideNavEntryMapping.SUBMIT_FOR_REVIEW))